import $ from "jquery";

export function hamburger() {
  //var siteHeader = "var(--site-header-height)";
  /* Hamburger */
  $(".site-header__hamburger-cta").click(function () {
    $("body").toggleClass("nav-active");
    setTimeout(function () {
      var siteHeader = $(".site-header").height();

      $(".main-navigation-wrapper").css("top", siteHeader + "px");
      $(this).toggleClass("is-active");
      $(".main-navigation-wrapper").toggleClass(
        "main-navigation-wrapper--active",
      );
      //.toggleClass("main-navigation-wrapper--active").slideToggle(280, "swing");
      //$(".site-header__navigation").slideToggle();
    }, 200);
  });

  function addBackButtons() {
    if (window.innerWidth <= 768) {
      // adjust breakpoint as needed
      document
        .querySelectorAll("[aria-haspopup='true'] + ul")
        .forEach((flyout) => {
          if (!flyout.querySelector(".flyout-back-btn")) {
            const backLi = document.createElement("li");
            backLi.className = "flyout-back-btn";
            backLi.style.cursor = "pointer";

            const icon = document.createElement("span");
            icon.className = "material-icons-outlined";
            icon.textContent = "chevron_left";

            const text = document.createElement("span");
            text.className = "flyout-back-text";
            text.textContent = "zurück";

            backLi.appendChild(icon);
            backLi.appendChild(text);

            flyout.insertBefore(backLi, flyout.firstChild);
          }
        });
    }
  }

  window.addEventListener("load", addBackButtons);
  window.addEventListener("resize", addBackButtons);
  // Handle click events for triggers & back buttons
  document.addEventListener("click", function (e) {
    const triggerSelector = "[aria-haspopup='true']";

    // Handle back button
    if (e.target.classList.contains("flyout-back-btn")) {
      const currentFlyout = e.target.closest("ul");
      currentFlyout.style.display = "none";

      // Show parent flyout (previous level)
      const parentTrigger = currentFlyout
        .closest("li")
        ?.closest("ul")?.previousElementSibling;
      if (parentTrigger && parentTrigger.tagName.toLowerCase() === "ul") {
        parentTrigger.style.display = "block";
      }
      return;
    }

    // Handle trigger click
    if (e.target.matches(triggerSelector)) {
      const isSecondLevel = e.target.classList.contains("menu-list-link");
      const flyout = e.target.nextElementSibling;

      if (isSecondLevel) {
        e.target
          .closest("ul")
          .querySelectorAll(`${triggerSelector} + ul`)
          .forEach((submenu) => {
            if (submenu !== flyout) submenu.style.display = "none";
          });
      } else {
        document
          .querySelectorAll(`${triggerSelector} + ul`)
          .forEach((submenu) => {
            submenu.style.display = "none";
          });
      }

      e.target.focus();
      if (flyout && flyout.tagName.toLowerCase() === "ul") {
        flyout.style.display = "block";
        flyout.style.transformOrigin = "left";
        flyout.style.animation = "flyout 0.2s ease-out";
      }
    } else {
      document
        .querySelectorAll(`${triggerSelector} + ul`)
        .forEach((submenu) => {
          submenu.style.display = "none";
        });
    }

    //set min-height for main-navigation-wrapper--active by height of container .menu.menu-list displayed block
    const mainNav = document.querySelector(".main-navigation-wrapper");
    if (mainNav) {
      const menuList = mainNav.querySelector(".menu.menu-list");
      if (menuList) {
        mainNav.style.minHeight = menuList.offsetHeight + 60 + "px";
      }
    }
  });
}
